import type { TFunction } from 'i18next';
import type { RefSource, Transformation } from '../../../../lib/correspondance.js';

/** Une source en une ligne : « Prix TTC », « Prix de vente (prix) », « artiste.nom (parent) ». */
export function libelleRef(t: TFunction, reference: RefSource): string {
  const suffixes: string[] = [];
  if (reference.role !== null) suffixes.push(reference.role);
  if (reference.parent) suffixes.push(String(t('correspondance.editeur.parentCourt')));
  return suffixes.length === 0 ? reference.champ : `${reference.champ} (${suffixes.join(', ')})`;
}

/** Une transformation en une ligne, paramètres compris, pour les vues en lecture. */
export function libelleTransformation(t: TFunction, etape: Transformation): string {
  const nom = String(t(`correspondance.transformations.${etape.type}`));
  switch (etape.type) {
    case 'scinder': {
      // Un séparateur d'espaces ne se voit pas entre guillemets : on le nomme.
      const separateur =
        etape.separateur.trim() === ''
          ? String(t('correspondance.editeur.espaceCourt'))
          : `« ${etape.separateur} »`;
      return `${nom} (${separateur}, ${String(etape.index)})`;
    }
    case 'date':
      return `${nom} (${etape.format})`;
    case 'montant':
      return `${nom} (${String(t('correspondance.editeur.decimalCourt'))} « ${etape.decimal} »${etape.devise ? `, ${etape.devise}` : ''})`;
    case 'dictionnaire': {
      // Un dictionnaire vide qui n'a qu'une valeur par défaut (« tout texte devient oui ») le dit.
      const nombre = Object.keys(etape.valeurs).length;
      const parties: string[] = [];
      if (nombre > 0 || etape.defaut === undefined)
        parties.push(String(t('correspondance.editeur.valeurs', { count: nombre })));
      if (etape.defaut !== undefined)
        parties.push(
          `${String(t('correspondance.editeur.valeurParDefaut')).toLowerCase()} « ${etape.defaut} »`,
        );
      return `${nom} (${parties.join(', ')})`;
    }
    case 'constante':
    case 'prefixe':
      return `${nom} (« ${etape.valeur} »)`;
    case 'si_vide':
      return `${nom} (${etape.source ? libelleRef(t, etape.source) : `« ${etape.valeur ?? ''} »`})`;
    case 'concat':
      return `${nom} (${libelleRef(t, etape.source)})`;
    default:
      return nom;
  }
}
